import { DataTypeLti } from '@efdigital/ll-admin-v2/data/data-types/lti';
import type { JsonApiDocument } from '@efdigital/ll-admin-v2/data/normalizers/jsonapi-document';
import type {
  ConsumedTool,
  ConsumedToolListResponse,
} from '@efdigital/ll-cdk-lti-registration-api-types';

export function consumedToolToJsonApiResource(tool: ConsumedTool) {
  return {
    type: DataTypeLti.ConsumedTool,
    id: tool.id,
    attributes: {
      consumingPlatformId: tool.consumingPlatformId,
      providedToolId: tool.providedToolId,
      platformData: tool.platformData,
      createdAt: tool.createdAt,
      updatedAt: tool.updatedAt,
    },
  };
}

export function consumedToolToJsonApiDocument(
  tool: ConsumedTool
): JsonApiDocument {
  return {
    data: consumedToolToJsonApiResource(tool),
  };
}

export function listConsumedToolsResponseToJsonApiDocument(
  response: ConsumedToolListResponse
): JsonApiDocument {
  return {
    data: response.map(consumedToolToJsonApiResource),
  };
}
